
export default {
    notifications: {},
    aggregate: {},
    treeNotificationsList: [
        {
            className: "text-danger",
            title: "No roadmap link",
            globalIcon: "signpost-split",
            localIcon: "signpost-split-fill",
            type: "no-roadmap"
        },
        /*{
            className: "text-danger",
            title: "No tag",
            globalIconoan: "bookmark",
            localIcon: "bookmark-fill",
            type: "no-tag"
        },*/
        {
            className: "text-danger",
            title: "No deadline set",
            globalIcon: "exclamation-octagon",
            localIcon: "exclamation-octagon-fill",
            type: "no-deadline"
        },
        {
            className: "text-info",
            title: "Node has roadmap",
            globalIcon: "signpost-split",
            localIcon: "signpost-split-fill",
            type: "has-roadmap"
        },
        {
            className: "text-danger",
            title: "No assignees",
            globalIcon: "cone-striped",
            localIcon: "cone",
            type: "incomplete"
        },
        {
            className: "text-danger",
            title: "Deadline reached",
            globalIcon: "alarm-fill",
            localIcon: "alarm-fill",
            type: "deadline"
        },
        /*{
            className: "text-danger",
            title: "No estimate set",
            globalIcon: "clock-history",
            localIcon: "clock-history",
            type: "no-estimate"
        },*/
        {
            className: "text-danger",
            title: "Spent more than planned",
            globalIcon: "emoji-angry",
            localIcon: "emoji-angry",
            type: "overlogged"
        },
        {
            className: "text-danger",
            title: "Forgotten task",
            globalIcon: "hourglass-split",
            localIcon: "hourglass",
            type: "forgotten-task"
        },

        {
            className: "text-info",
            title: "Task for today",
            globalIcon: "calendar-check",
            localIcon: "calendar-check",
            type: "task-4-today"
        },
        {
            className: "text-info",
            title: "My tasks for today",
            globalIcon: "calendar-check-fill",
            localIcon: "calendar-check-fill",
            type: "my-task-4-today"
        },
        {
            className: "text-danger",
            title: "You were mentioned",
            globalIcon: "at",
            localIcon: "at",
            type: "mention-comment"
        },
        {
            className: "text-secondary",
            title: "Unread message",
            globalIcon: "chat-square",
            localIcon: "chat-square-fill",
            type: "comment"
        },

        {
            className: "text-primary",
            title: "My tasks",
            globalIcon: "person-fill",
            localIcon: "person-fill",
            type: "assignee"
        },
        {
            className: "text-info",
            title: "Available tasks",
            globalIcon: "person",
            localIcon: "person",
            type: "assignee_position"
        },

        {
            className: "text-info",
            title: "Can be approved",
            globalIcon: "star",
            localIcon: "star",
            type: "acceptor_position"
        },
        {
            className: "text-info",
            title: "Should be approved",
            globalIcon: "star-fill",
            localIcon: "star-fill",
            type: "acceptor"
        },
        {
            className: "text-info",
            title: "Task in progress",
            globalIcon: "file-play-fill",
            localIcon: "file-play",
            type: "in-progress"
        },
        {
            className: "text-info",
            title: "Favorite tasks",
            globalIcon: "heart",
            localIcon: "heart-fill",
            type: "favorite"
        },
        {
            className: "text-info",
            title: "Node KPIs",
            globalIcon: "bar-chart",
            localIcon: "bar-chart-fill",
            type: "has-kpi"
        },

        {
            className: "text-danger",
            title: "KPI problems",
            globalIcon: "bar-chart",
            localIcon: "bar-chart-fill",
            type: "problem-kpi"
        },

    ],
    notificationSettings: {}
}
